/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2015, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.searchModule')

.controller('SearchResultsController', ['$log','$q','$stateParams','BulbErrorService','BulbSearchService','initialResults','SEARCH', SearchResultsController]);

function SearchResultsController($log, $q, $stateParams, BulbErrorService, BulbSearchService, initialResults, SEARCH) {
  var that = this;

  this.query = $stateParams.query;
  this.userUnitId = $stateParams.userUnitId || null;
  this.scope = $stateParams.scope || ($stateParams.userUnitId ? 'PORTFOLIO' : 'ALL');

  this.results = {
    totalResults: 0,
    units: []
  };
  this.from = 0;

  // required by bulbInfiniteScrollWindow directive,
  // which $watches this value and stops handling window scroll when it becomes false.
  this.infiniteScrollWindowEnabled = true;

  // initialization
  function initialize() {
    if (initialResults) {
      $log.debug('searchResultsCtrl: initialize: initializing');
      that.results.totalResults = initialResults.totalResults;
      that.results.query = initialResults.query;
      if (initialResults.unitDTOs) {
        that.results.units = initialResults.unitDTOs;
        that.from = initialResults.unitDTOs.length;
        if (that.from >= that.results.totalResults) {
          $log.debug('searchResultsCtrl.initialize: disabling scroll');
          that.infiniteScrollWindowEnabled = false;
        }
      }
      return true;
    } else {
      $log.error('searchResultsCtrl: initialize: no initialResults');
      return false;
    }
  }

  this.initialized = initialize();

  /**
   * Required by bulbInfiniteScrollWindow directive,
   * which calls this function to load another batch of search results.
   * Clears infiniteScrollWindowEnabled when all results have been loaded.
   * @returns A promise, already resolved if no more results to get, or resolved when the request returns.
   */
  this.getNextPage = function() {
    var deferred = $q.defer();
    if (!this.initialized) {
      // not ready
      var message = 'searchResultsCtrl.getNextPage: not initialized';
      $log.error(message);
      deferred.reject(message);
    } else if (this.from < this.results.totalResults) {
      // more results to load
      $log.debug('searchResultsCtrl.getNextPage: loading more results');
      BulbSearchService.search(this.results.query, this.userUnitId, this.scope, this.from, SEARCH.SEARCH_RESULTS_SIZE)
      .then(function(results) {
        if (results.unitDTOs && results.unitDTOs.length > 0) {
          that.results.units = that.results.units.concat(results.unitDTOs);
          that.from += results.unitDTOs.length;
          // if finished, disable window scroll event handler
          if (that.from >= that.results.totalResults) {
            $log.debug('searchResultsCtrl.getNextPage: disabling scroll');
            that.infiniteScrollWindowEnabled = false;
          }
          deferred.resolve();
        }
      }, function(error) {
        BulbErrorService.error('Cannot get next search results', error);
        deferred.reject(error);
      });
    } else {
      // no more results to load: disable window scroll event handler
      $log.debug('searchResultsCtrl.getNextPage: no more results: disabling scroll');
      that.infiniteScrollWindowEnabled = false;
      deferred.resolve();
    }
    return deferred.promise;
  };
}
